import { CharacterDetailsActionType } from '#/redux/actions/characterDetails';
import { TAppDispatch, TRootState } from '#/redux/store';
import ApiManager from '#/services/api/ApiManager';
import { apiConfig } from '#/utils/constants';
import generateAuthParams from '#/utils/generateHash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import './CharacterDetails.style.scss';
import { IMarvelAPIResponse } from '#/types/common';
import ICharacter from '#/types/characters';
import { useError } from '#/hooks/useError/useError';

const CharacterDetails = () => {
  const { addError } = useError();

  const { characterId } = useParams();

  const characterDetailsSelector = (state: TRootState) =>
    state.characterDetails;

  const { character } = useSelector(characterDetailsSelector);

  const dispatch = useDispatch<TAppDispatch>();

  useEffect(() => {
    const getCharacterDetails = async () => {
      const apiManager = new ApiManager(apiConfig);

      if (characterId) {
        const response = await apiManager.getEntity<
          IMarvelAPIResponse<ICharacter>
        >('CHARACTERS', characterId, generateAuthParams());

        if ('error' in response) {
          addError(response.error);
        } else {
          if (response.data.data?.results) {
            dispatch({
              type: CharacterDetailsActionType.CHARACTER_DETAILS_SET_CHARACTER_DETAILS,
              payload: response.data.data.results[0],
            });
          }
        }
      }
    };

    getCharacterDetails();

    return () => {
      dispatch({
        type: CharacterDetailsActionType.CHARACTER_DETAILS_SET_CHARACTER_DETAILS,
        payload: undefined,
      });
    };
  }, [addError, characterId, dispatch]);

  return (
    <div>
      <div
        className="characterDetails--image"
        style={{
          backgroundImage: `url(${character?.thumbnail?.path}/landscape_incredible.${character?.thumbnail?.extension})`,
        }}
      />

      <h1>{character?.name}</h1>

      <p
        className="characterDetails--description"
        dangerouslySetInnerHTML={{
          __html: character?.description ? character?.description : '',
        }}
      />

      <h2>Comics</h2>

      <ul>
        {character?.comics?.items?.length === 0 ? (
          <li>Comics not found</li>
        ) : (
          character?.comics?.items?.map((comic) => (
            <li key={comic.name}>{comic.name}</li>
          ))
        )}
      </ul>

      <h2>Stories</h2>

      <ul>
        {character?.stories?.items?.length === 0 ? (
          <li>Stories not found</li>
        ) : (
          character?.stories?.items?.map((stories) => (
            <li key={stories.name}>{stories.name}</li>
          ))
        )}
      </ul>
    </div>
  );
};

export default CharacterDetails;
